import axios from "axios"
import URLConfig from '../service/URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();
// Fail auth requests instead of leaving the form spinning on a slow backend.
const AUTH_REQUEST = { timeout: 15000 };

class AuthenticationService {

    registerSuccessfulUser(accessToken, userType) {
        localStorage.setItem('lisianthus_user', accessToken)
        localStorage.setItem('token', accessToken)
        localStorage.setItem('note_book_access', 1)
        localStorage.setItem('user_type', userType)
        console.log("storage added")
    }

    logout() {
        localStorage.removeItem('lisianthus_user')
        localStorage.removeItem('note_book_access')
        localStorage.removeItem('token')
        localStorage.removeItem('user_type')
        localStorage.setItem('logout', 1)
        localStorage.removeItem('userName')
        localStorage.removeItem('isAdmin')
        localStorage.removeItem('role')
        localStorage.removeItem('canManageSettings')
        localStorage.removeItem('time')
        localStorage.removeItem('hasProfile')
        localStorage.removeItem('userType')
        console.log("storage removed")
        //  window.location.reload();
    }
    getLogout() {
        let log = localStorage.getItem('logout')
        if (log === null) return false
        else return true
    }
    removeLog() {
        localStorage.removeItem('logout')
    }

    saveLogInCount() {
        localStorage.setItem('login-count', 1)
    }

    getLogInCount() {
        let log = localStorage.getItem('login-count')
        if (log === null) return false
        else return true
    }

    removeLogInCount() {
        localStorage.removeItem('login-count')
    }

    getUserName() {
        return localStorage.getItem('lisianthus_user').toUpperCase();
    }

    getAuthUserName() {
        return localStorage.getItem('userName');
    }

    getLocalStroageByKey(key) {
        return localStorage.getItem(key);
    }

    // ADMIN, MANAGER or USER
    getRole() {
        return localStorage.getItem('role') || 'USER';
    }

    canManageSettings() {
        return localStorage.getItem('canManageSettings') === 'true';
    }

    getIsAdmin() {
        return localStorage.getItem('isAdmin');
    }
    queryData() {
        

      if(localStorage.getItem('time') === null){
         return true;
      }else{
        const old = parseInt(localStorage.getItem('time'));
        let now = Math.abs(new Date().getTime());
        const diff = (now - old)/1000;
        // console.log("Storage last updated in seconds: "+ diff)
        if(diff > 3000){
            return true
        }else 
        {
            return false;
        }
      }

    }

    savePreferenceInCount() {
        localStorage.setItem('preference-count', 1)
    }

    isPreferenceExist() {
        let log = localStorage.getItem('preference-count')
        if (log === null) return false
        else return true
    }
    removePreferenceCount() {
        localStorage.removeItem('preference-count')
    }

    isUserLoggedIn() {
        let username = localStorage.getItem('lisianthus_user')
        if (username === null) return false
        else return true
    }
    isUserTypeExist() {
        let userType = localStorage.getItem('user_type')
        if (userType == 1 || userType == 0) return true
        else return false
    }
    isNoteBookAppAccess() {
        let noteBookAccess = localStorage.getItem('note_book_access')
        if (noteBookAccess === null) return false;
        else if (noteBookAccess == 1) return true;
        else return false;
    }
    loginApi(loginform) {
        return axios.post(path + "/api/auth/signin", loginform, AUTH_REQUEST);
    }
    regiserUser(registerform) {
        return axios.post(path + "/api/auth/signup", registerform, AUTH_REQUEST);
    }

    // "Continue with Google": the ID token from Google Identity Services; same response as loginApi
    googleLogin(idToken) {
        return axios.post(path + "/api/auth/google", { idToken }, AUTH_REQUEST);
    }

    // { clientId } for Google's button; blank when an admin has Google sign-in off (Settings)
    googleConfig() {
        return axios.get(path + "/api/auth/google/config", AUTH_REQUEST);
    }

    sendResetCode(email){
        return axios.post(path + "/api/auth/reset?email=" + encodeURIComponent(email), null, AUTH_REQUEST);
    }

    verifyAndUpdatePassword(email, code, password){
        return axios.post(path + "/api/auth/updatePassword?email=" + encodeURIComponent(email) + "&code=" + encodeURIComponent(code) + "&password=" + encodeURIComponent(password), null, AUTH_REQUEST);
    }

    verifyEmail(email){
        return axios.post(path + "/api/auth/verifyEmail/" + encodeURIComponent(email), null, AUTH_REQUEST);
    }

    saveUserDeviceInfo(info) {
        return axios.post(path + "/user/info/" + info);
    }

    getUser() {
        return axiosInstance().get(path + "/user");
    }
    getUserList() {
        return axiosInstance().get(path + "/user/list");
    }

    getUserDetails() {
        return axiosInstance().get(path + "/shop/account/profile");
    }

    getServerTime() {
        return axiosInstance().get(path + "/api/auth/serverTime");
    }

    // isAdmin is true for admins and managers (admin screens); only admins may open Settings
    updateAuthData(userName, isAdmin, hasProfile, userType, role, canManageSettings) {
        let time = Math.abs(new Date().getTime());
        localStorage.setItem('userName', userName)
        localStorage.setItem('isAdmin', isAdmin)
        localStorage.setItem('role', role || (isAdmin ? 'ADMIN' : 'USER'))
        localStorage.setItem('canManageSettings', canManageSettings === true)
        localStorage.setItem('time', time)
        localStorage.setItem('hasProfile', hasProfile)
        localStorage.setItem('userType', userType)
        console.log("authData updated")
    }

    // onboarding finished: the customer may now order
    markProfileComplete(){
        localStorage.setItem('hasProfile', true)
    }
   

}

export default new AuthenticationService()